import React, { useEffect, useState } from 'react';
import { ReactComponent as MoveCookbookSearchIcon } from '../../Icons/search.svg';
import './MoveCookbookMenu.css';

const tabOptions = [{ key: 'collections', label: 'Collections' }];

export default function MoveCookbookMenu({
  open,
  onClose,
  cookbook,
  collections = [],
  onMoveToCollection,
}) {
  const [activeTab, setActiveTab] = useState('collections');
  const [search, setSearch] = useState('');

  useEffect(() => {
    if (!open) {
      setSearch('');
      setActiveTab('collections');
    }
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open || !cookbook) return null;

  const filteredCollections = collections.filter((c) =>
    c.name.toLowerCase().includes(search.toLowerCase())
  );

  let listContent;
  if (activeTab === 'collections') {
    listContent =
      filteredCollections.length === 0 ? (
        <p className="deck-manager-move-cookbook-menu__empty">No collections</p>
      ) : (
        <ul className="deck-manager-move-cookbook-menu__list">
          {filteredCollections.map((collection) => (
            <li key={collection.id}>
              <button
                type="button"
                className="deck-manager-move-cookbook-menu__collection-btn"
                onClick={() => onMoveToCollection(cookbook, collection)}
              >
                {collection.name}
              </button>
            </li>
          ))}
        </ul>
      );
  }

  return (
    <div
      className="deck-manager-move-cookbook-menu__backdrop"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="deck-manager-move-cookbook-menu__panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="deck-manager-move-cookbook-menu-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="deck-manager-move-cookbook-menu__accent" aria-hidden />

        <div className="deck-manager-move-cookbook-menu__header">
          <h2 id="deck-manager-move-cookbook-menu-title" className="deck-manager-move-cookbook-menu__title">
            Move to collection
          </h2>
        </div>

        <div className="deck-manager-move-cookbook-menu__tabs" role="tablist" aria-label="Destination">
          {tabOptions.map((tab) => (
            <button
              key={tab.key}
              type="button"
              role="tab"
              aria-selected={activeTab === tab.key}
              className={`deck-manager-move-cookbook-menu__tab${
                activeTab === tab.key ? ' deck-manager-move-cookbook-menu__tab--active' : ''
              }`}
              onClick={() => {
                setActiveTab(tab.key);
                setSearch('');
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <label className="deck-manager-move-cookbook-menu__search">
          <MoveCookbookSearchIcon
            className="deck-manager-move-cookbook-menu__search-icon"
            aria-hidden
          />
          <input
            type="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search collections..."
            className="deck-manager-move-cookbook-menu__search-input"
            autoFocus
          />
        </label>

        <div className="deck-manager-move-cookbook-menu__body">{listContent}</div>

        <button
          type="button"
          className="deck-manager-move-cookbook-menu__btn-cancel"
          onClick={onClose}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
